// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NbWuh","rootNoMargin":"styles_rootNoMargin__37oew"};